
import { Parametric } from '../../cliente/parametric.model';
import { BackendModel, BackendService } from '../../core/backend.service';
import { Color } from '../color/color.model';


export class ImagenDisplay extends BackendModel {

  static path = 'subir_imagen';
  file: File;
  path: string;
  id: number;
  name: string;
  archivoId: number;
  url?: any;
  color: Color;
  colores: Color[];
  tipoImagen: Parametric;
  width_imagen: number;
  height_imagen: number;
  resource: File;

}


// WEBPACK FOOTER //
// ./src/app/productos/dtos/imagen-display.ts